const searchTypes = {
  PACKAGES: 'packages',
  TITLES: 'titles',
  PROVIDERS: 'providers',
};

export default searchTypes;
